export default {
  name: 'CardDesc',
  props: {
    userInfo: Object
  },
  data: function data() {
    return {
      introState: true
    };
  },
  methods: {
    changeState: function changeState() {
      this.introState = !this.introState;
    }
  }
};